import type { IconProps } from '../types/IconProps.ts';
export const Baseline: IconProps = {
    name: 'Baseline',
    children: [
        `<path d="M4 20h16M18 16 12.02 4.04a.02.02 0 0 0-.04 0L6 16M8 12h8" />`,
    ]
};